export default "__VITE_ASSET__CHJ7vt4l__"